import Vue from "vue";
import Vuex from "vuex";
import school from "./school";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userinfo: {},
    son_list: [],
    play_index: {},
    commodityList: [],
    coupon: {
      "text": {
        "couponName": "",
        "couponAmt": null,
        "issuanceId": null,
        "couponDesc": "",
        "couponId": null,
        "timeOut": null
      }
    },
    privatesmsList: [],
  },
  getters: {},
  mutations: {
    change_userinfo(state, val) {
      state.userinfo = val;
      console.log(state.userinfo);
    },
    change_son_list(state, val) {
      state.son_list = val;
      console.log(state.son_list);
    },
    change_play_index(state, val) {
      state.play_index = val;
      console.log(state.play_index);
    },
    // 商品列表
    updateCommodityList(state, val) {
      state.commodityList = val;
    },
    // 上架/推荐商品
    saleCommodityList(state, goods) {
      const index = state.commodityList.findIndex(
        (item) => item.productId === goods.productId
      );
      if (index !== -1) {
        state.commodityList.splice(index, 1);
      }
      let array = state.commodityList;
      array.push(goods);
      array.sort((a, b) => a.productCode - b.productCode);
      state.commodityList = array
        .filter((item) => item.productStatus === "recommendIng")
        .concat(array.filter((item) => item.productStatus !== "recommendIng"));
    },
    //  推荐商品
    recommendIng(state, goods) {
      const index = state.commodityList.findIndex((item) => {
        if (item.productRecommendStatus === "recommendIng") {
          item.productRecommendStatus = "unrecommend";
        }
        return item.productId === goods.productId;
      });
      if (index !== -1) {
        state.commodityList.splice(index, 1);
      }
      // 进行排序
      let array = state.commodityList;
      array.push(goods);
      array.sort((a, b) => a.productCode - b.productCode);
      state.commodityList = array
        .filter((item) => item.productRecommendStatus === "recommendIng")
        .concat(
          array.filter((item) => item.productRecommendStatus !== "recommendIng")
        );
    },
    // 下架商品
    unSaleCommodityList(state, itemId) {
      const index = state.commodityList.findIndex(
        (item) => item.productId === itemId
      );
      if (index !== -1) {
        state.commodityList.splice(index, 1);
      }
      // 进行排序
      let array = state.commodityList;
      array.sort((a, b) => a.productCode - b.productCode);
      state.commodityList = array
        .filter((item) => item.productRecommendStatus === "recommendIng")
        .concat(
          array.filter((item) => item.productRecommendStatus !== "recommendIng")
        );
    },
    // 取消推荐
    unRecommendIng(state, itemId) {
      const index = state.commodityList.findIndex((item) => {
        if (item.productRecommendStatus === "recommendIng") {
          item.productRecommendStatus = "unrecommend";
        }
        return item.productId === itemId;
      });
      if (index !== -1) {
        state.commodityList[index].productRecommendStatus = "unrecommend";
      }
      // 进行排序
      let array = state.commodityList;
      array.sort((a, b) => a.productCode - b.productCode);
      state.commodityList = array
        .filter((item) => item.productRecommendStatus === "recommendIng")
        .concat(array.filter((item) => item.productRecommendStatus !== "recommendIng"));
    },
    // 售罄
    sellOut(state, params) {
      const index = state.commodityList.findIndex(
        (item) => item.productId === params.productId
      );
      if (index !== -1) {
        state.commodityList[index].productSellOutStatus = params.status;
      }
    },

    updateprivatesmsList(state, val) {
      state.privatesmsList = val;
    },
    // 设置优惠券
    set_coupon(state, val) {
      state.coupon = val
    }

  },
  actions: {},
  modules: {
    school,
  },
});
export default store;
